'use client';

import { Icons } from '../icons';
import { Button } from '../ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { useWorkflows } from '@/providers/workflow-provider';

interface ToggleAllWorkflowsButtonProps {
  readonly folderIds: string[];
  readonly accordionKey: 'dashboard' | 'workflows';
}

export function ToggleAllWorkflowsButton({
  folderIds,
  accordionKey,
}: ToggleAllWorkflowsButtonProps) {
  const { workflowSettings, setWorkflowSettings } = useWorkflows();

  if (folderIds.length === 0) return null;

  const hasOpenAccordions = (
    workflowSettings.expandedItems[accordionKey] ?? []
  ).some((id) => folderIds.includes(id));

  const toggleAll = () => {
    const current = workflowSettings.expandedItems[accordionKey] ?? [];
    const next = hasOpenAccordions
      ? current.filter((id) => !folderIds.includes(id))
      : [...new Set([...current, ...folderIds])];

    setWorkflowSettings({
      ...workflowSettings,
      expandedItems: {
        ...workflowSettings.expandedItems,
        [accordionKey]: next,
      },
    });
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          className='relative'
          variant='outline'
          size='icon'
          onClick={toggleAll}
        >
          {hasOpenAccordions ? (
            <Icons.collapseAll className='size-4' />
          ) : (
            <Icons.expandAll className='size-4' />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent className='font-normal'>
        {hasOpenAccordions ? 'Fäll ihop alla' : 'Expandera alla'}
      </TooltipContent>
    </Tooltip>
  );
}
